"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BrowseFilter = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _index = _interopRequireDefault(require("./index.styled"));

var _Filter = require("./Filter");

var _Sort = require("./Sort");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var BrowseFilter = function BrowseFilter(_ref) {
  var matchedNum = _ref.matchedNum,
      totalNum = _ref.totalNum,
      _ref$resetFunction = _ref.resetFunction,
      resetFunction = _ref$resetFunction === void 0 ? function () {} : _ref$resetFunction,
      _ref$filters = _ref.filters,
      filters = _ref$filters === void 0 ? [] : _ref$filters,
      _ref$sort = _ref.sort,
      sort = _ref$sort === void 0 ? [] : _ref$sort,
      _ref$sortFunction = _ref.sortFunction,
      sortFunction = _ref$sortFunction === void 0 ? function () {} : _ref$sortFunction;

  var handleReset = function handleReset() {
    resetFunction();
    var inputs = document.querySelectorAll('input');
    inputs.forEach(function (item) {
      return item.checked = false;
    });
  };

  return /*#__PURE__*/_react.default.createElement(_index.default.BrowseFilter, null, /*#__PURE__*/_react.default.createElement("div", {
    id: "opportunities-label"
  }, matchedNum !== totalNum && matchedNum !== 0 && "".concat(matchedNum, " / "), totalNum, " Opportunities"), /*#__PURE__*/_react.default.createElement("div", {
    id: "filterby-line"
  }, /*#__PURE__*/_react.default.createElement("div", {
    id: "filterby-label"
  }, "SORT BY")), /*#__PURE__*/_react.default.createElement(_Sort.Sort, {
    sort: sort,
    sortFunction: sortFunction
  }), /*#__PURE__*/_react.default.createElement("div", {
    id: "filterby-line"
  }, /*#__PURE__*/_react.default.createElement("div", {
    id: "filterby-label"
  }, "FILTER BY"), /*#__PURE__*/_react.default.createElement("button", {
    id: "reset-button",
    onClick: handleReset
  }, "RESET")), filters.map(function (eachFilter, index) {
    return /*#__PURE__*/_react.default.createElement(_Filter.Filter, {
      key: eachFilter.label,
      groupNum: index,
      label: eachFilter.label,
      filters: eachFilter.filters,
      filterFunction: eachFilter.filterFunction
    });
  }));
}; // BrowseFilter.propTypes = {
//   /**
//    * Default width is 100%, override with this prop (eg: '250px')
//    **/
//   width: PropTypes.string,
// }


exports.BrowseFilter = BrowseFilter;